// Countries for the English page: the full list for the check/wire/DAF form's
// country picker, and which of the page's currencies a visitor's country
// preselects.
//
// The list is generated from the browser's own region names (Intl.DisplayNames)
// rather than kept by hand: every two-letter code the browser can name is a
// real region, and anything it can't name comes back unchanged and is dropped.
// currencies.js's COUNTRIES is IsraelGives' short list (ids, ~30 entries) and
// is the wrong tool here — an offline donation can come from anywhere.

// Codes that DisplayNames names but that aren't countries a donor lives in.
const NOT_COUNTRIES = new Set(['EU', 'EZ', 'UN', 'QO', 'XA', 'XB', 'ZZ', 'AQ', 'BV', 'HM', 'TF', 'UM']);

function buildCountryList() {
  let names;
  try {
    names = new Intl.DisplayNames(['en'], { type: 'region' });
  } catch {
    return [];
  }
  const out = [];
  const A = 'A'.charCodeAt(0);
  for (let i = 0; i < 26; i += 1) {
    for (let j = 0; j < 26; j += 1) {
      const code = String.fromCharCode(A + i, A + j);
      if (NOT_COUNTRIES.has(code)) continue;
      let name;
      try {
        name = names.of(code);
      } catch {
        continue;
      }
      if (name && name !== code) out.push({ code, name });
    }
  }
  return out.sort((a, b) => a.name.localeCompare(b.name, 'en'));
}

export const INTL_COUNTRIES = buildCountryList();

// Countries whose donors are asked for a state/province — the client's webhook
// payload carries a `state` field, and these are where it means something.
export const COUNTRIES_WITH_STATE = new Set(['US', 'CA', 'AU']);

// Eurozone members plus the microstates and others that use the euro officially.
const EURO_COUNTRIES = [
  'AT', 'BE', 'CY', 'DE', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'IE', 'IT', 'LT',
  'LU', 'LV', 'MT', 'NL', 'PT', 'SI', 'SK',
  'AD', 'MC', 'ME', 'SM', 'VA', 'XK',
];

const CURRENCY_BY_COUNTRY = {
  US: 'USD', GB: 'GBP', CA: 'CAD', IL: 'ILS', CH: 'CHF', LI: 'CHF', BR: 'BRL', AU: 'AUD',
  ...Object.fromEntries(EURO_COUNTRIES.map((c) => [c, 'EUR'])),
};

// The currency to preselect for a visitor from `countryCode`, or null when
// their country isn't one the page has a currency for — the client asked that
// nothing be preselected then.
export function currencyForCountry(countryCode) {
  return CURRENCY_BY_COUNTRY[String(countryCode || '').toUpperCase()] || null;
}
